import { styled } from "@linaria/react";
import React, { useState } from "react";
import ReactPlayer from "react-player";

const VideoContainer = styled.div`
  position: relative;
  width: fit-content;
`;

const VideoWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 12px;
  overflow: hidden;
  @media (max-width: 600px) {
    width: 100%;
    border-radius: 0;
  }
`;

const ButtonContainer = styled.div`
  position: absolute;
  background: var(--primary-bg-90);
  width: 100%;
  height: 100%;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 12px;
  @media (max-width: 600px) {
    width: 100%;
    border-radius: 0;
  }
`;

const PlayButton = styled.button`
  height: 80px;
  width: 80px;
  background: var(--primary);
  border: none;
  color: var(--white);
  border-radius: 10px;
  transition: all 250ms;
  :hover {
    filter: brightness(0.8);
  }
`;

const Video = ({
  src,
  autoPlay = true,
  loop = true,
  muted = true,
  playbackRate = 2,
  showControls = false,
}) => {
  const [playing, setPlaying] = useState(autoPlay);
  return (
    <VideoContainer>
      <ReactPlayer
        playing={playing}
        playbackRate={playbackRate}
        url={src}
        controls={playing && showControls}
        height={"100%"}
        width={"100%"}
        loop={loop}
        autoPlay={autoPlay}
        muted={muted}
        wrapper={VideoWrapper}
      />
      {showControls && !playing && (
        <ButtonContainer>
          <PlayButton onClick={() => setPlaying(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="40"
              height="40"
              viewBox="0 0 24 24"
              fill="none"
            >
              <path d="M7 4V20L20 12L7 4Z" fill="var(--white)" />
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M6.63415 3.34528C6.87134 3.21274 7.16167 3.21885 7.39307 3.36126L20.3931 11.3613C20.6149 11.4978 20.75 11.7396 20.75 12C20.75 12.2604 20.6149 12.5022 20.3931 12.6387L7.39307 20.6387C7.16167 20.7811 6.87134 20.7873 6.63415 20.6547C6.39696 20.5222 6.25 20.2717 6.25 20V4C6.25 3.72829 6.39696 3.47783 6.63415 3.34528ZM7.75 5.34217V18.6578L18.569 12L7.75 5.34217Z"
                fill="var(--white)"
              />
            </svg>
          </PlayButton>
        </ButtonContainer>
      )}
    </VideoContainer>
  );
};

export default Video;
